import React from 'react';

import classes from '../installPics.css';

import FourthInstallPic from '../../../../../../../assets/FourthInstallImg.jpg';

const ThirdInstallImg = () => (
    <div className={classes.installImages}>
        <img alt="Small commercial installation in South New Jersey" src={FourthInstallPic} className={classes.installImg} />
    </div>
);


export default ThirdInstallImg;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/PitchedRoofImages/FourthInstallImg.js